export var customTexts = function customTexts(strictLocalize) {
  return {
    actionPaymentCompleted: strictLocalize({
      id: "I8qY2N",
      defaultMessage: [{
        "type": 0,
        "value": "Paiement effectué"
      }]
    }),
    actionPaymentError: strictLocalize({
      id: "ZAyV+v",
      defaultMessage: [{
        "type": 0,
        "value": "Une erreur est survenue lors du traitement de la carte. Veuillez réessayer ou utiliser une autre carte."
      }]
    }),
    actionPostbackError: strictLocalize({
      id: "4nX2E/",
      defaultMessage: [{
        "type": 0,
        "value": "Une erreur s'est produite lors du traitement de votre action. Veuillez réessayer."
      }]
    }),
    clickToRetry: strictLocalize({
      id: "VtFpKp",
      defaultMessage: [{
        "type": 0,
        "value": "Le message n'a pas été remis. Actualisez le navigateur pour réessayer."
      }]
    }),
    clickToRetryForm: strictLocalize({
      id: "u15Uck",
      defaultMessage: [{
        "type": 0,
        "value": "Le formulaire n'a pas été envoyé. Pour réessayer, cliquez à n'importe quel endroit dans le formulaire."
      }]
    }),
    connectNotificationText: strictLocalize({
      id: "FNME6m",
      defaultMessage: [{
        "type": 0,
        "value": "Synchronisez votre conversation et continuez à nous envoyer des messages sur votre application préférée."
      }]
    }),
    connectNotificationSingleText: strictLocalize({
      id: "SQ7ADB",
      defaultMessage: [{
        "type": 0,
        "value": "Recevez une notification lorsque vous obtenez une réponse."
      }]
    }),
    conversationListHeaderText: strictLocalize({
      id: "8mVcn4",
      defaultMessage: [{
        "type": 0,
        "value": "Mes conversations"
      }]
    }),
    conversationListPreviewAnonymousText: strictLocalize({
      id: "d5Sp/y",
      defaultMessage: [{
        "type": 0,
        "value": "Quelqu'un"
      }]
    }),
    conversationListPreviewCarouselText: strictLocalize({
      id: "BNBuTY",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " a envoyé un message"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFileText: strictLocalize({
      id: "Um9Kpq",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " a envoyé un fichier"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFormText: strictLocalize({
      id: "1fsFts",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " a envoyé un formulaire"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFormResponseText: strictLocalize({
      id: "OMXLSv",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " a rempli un formulaire"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewImageText: strictLocalize({
      id: "8nkquk",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " a envoyé une image"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewLocationRequestText: strictLocalize({
      id: "p/7Vs+",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " a envoyé une demande de localisation"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewUserText: strictLocalize({
      id: "5p2Qih",
      defaultMessage: [{
        "type": 0,
        "value": "Vous"
      }]
    }),
    conversationListRelativeTimeJustNow: strictLocalize({
      id: "72Tqww",
      defaultMessage: [{
        "type": 0,
        "value": "À l'instant"
      }]
    }),
    conversationListRelativeTimeMinute: strictLocalize({
      id: "IjmHdR",
      defaultMessage: [{
        "type": 0,
        "value": "Il y a 1 minute"
      }]
    }),
    conversationListRelativeTimeMinutes: strictLocalize({
      id: "hBcPit",
      defaultMessage: [{
        "type": 0,
        "value": "Il y a "
      }, {
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " minutes"
      }]
    }, {
      valueTime: "{value}"
    }),
    conversationListRelativeTimeHour: strictLocalize({
      id: "GZ73D9",
      defaultMessage: [{
        "type": 0,
        "value": "Il y a 1 heure"
      }]
    }),
    conversationListRelativeTimeHours: strictLocalize({
      id: "D1AceC",
      defaultMessage: [{
        "type": 0,
        "value": "Il y a "
      }, {
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " heures"
      }]
    }, {
      valueTime: "{value}"
    }),
    conversationListRelativeTimeYesterday: strictLocalize({
      id: "9Cwjfp",
      defaultMessage: [{
        "type": 0,
        "value": "Hier"
      }]
    }),
    couldNotConnect: strictLocalize({
      id: "UjUBuG",
      defaultMessage: [{
        "type": 0,
        "value": "Hors ligne. Vous ne recevrez pas de messages."
      }]
    }),
    couldNotConnectRetry: strictLocalize({
      id: "kXGiZU",
      defaultMessage: [{
        "type": 0,
        "value": "Reconnexion…"
      }]
    }),
    couldNotConnectRetrySuccess: strictLocalize({
      id: "WxKYO6",
      defaultMessage: [{
        "type": 0,
        "value": "Vous êtes de nouveau en ligne !"
      }]
    }),
    couldNotLoadConversations: strictLocalize({
      id: "NT287R",
      defaultMessage: [{
        "type": 0,
        "value": "Impossible de charger les conversations."
      }]
    }),
    emailChangeAddress: strictLocalize({
      id: "lMdZaG",
      defaultMessage: [{
        "type": 0,
        "value": "Modifier mon adresse e-mail"
      }]
    }),
    emailDescription: strictLocalize({
      id: "FtDtu+",
      defaultMessage: [{
        "type": 0,
        "value": "Pour recevoir une notification par e-mail lorsque vous obtenez une réponse, saisissez votre adresse e-mail."
      }]
    }),
    emailFieldLabel: strictLocalize({
      id: "3bcv4v",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    emailFieldPlaceholder: strictLocalize({
      id: "2L9ili",
      defaultMessage: [{
        "type": 0,
        "value": "Votre adresse e-mail"
      }]
    }),
    emailFormButton: strictLocalize({
      id: "OCxMgt",
      defaultMessage: [{
        "type": 0,
        "value": "Envoyer"
      }]
    }),
    emailLinkingErrorMessage: strictLocalize({
      id: "pJuL3D",
      defaultMessage: [{
        "type": 0,
        "value": "Veuillez saisir une adresse e-mail valide."
      }]
    }),
    fetchHistory: strictLocalize({
      id: "n288kk",
      defaultMessage: [{
        "type": 0,
        "value": "Charger plus"
      }]
    }),
    fetchingHistory: strictLocalize({
      id: "p0LVGs",
      defaultMessage: [{
        "type": 0,
        "value": "Récupération de l'historique…"
      }]
    }),
    fileTooLargeError: strictLocalize({
      id: "Yl3C6g",
      defaultMessage: [{
        "type": 0,
        "value": "Le fichier dépasse la taille limite ("
      }, {
        "type": 1,
        "value": "sizeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      sizeNumber: "{size}"
    }),
    fileTypeError: strictLocalize({
      id: "GpVgdA",
      defaultMessage: [{
        "type": 0,
        "value": "Type de fichier non pris en charge."
      }]
    }),
    formErrorEntryRequired: strictLocalize({
      id: "U6eN9Z",
      defaultMessage: [{
        "type": 0,
        "value": "Ce champ doit être complété"
      }]
    }),
    formErrorInvalidEmail: strictLocalize({
      id: "CfLksk",
      defaultMessage: [{
        "type": 0,
        "value": "L'adresse e-mail n'est pas valide"
      }]
    }),
    formErrorNoLongerThan: strictLocalize({
      id: "gZ/mqf",
      defaultMessage: [{
        "type": 0,
        "value": "Ne doit pas contenir plus de "
      }, {
        "type": 1,
        "value": "charactersNumber"
      }, {
        "type": 0,
        "value": " caractères"
      }]
    }, {
      charactersNumber: "{characters}"
    }),
    formErrorNoShorterThan: strictLocalize({
      id: "6UhNRq",
      defaultMessage: [{
        "type": 0,
        "value": "Doit comporter au moins "
      }, {
        "type": 1,
        "value": "charactersNumber"
      }, {
        "type": 0,
        "value": " caractères"
      }]
    }, {
      charactersNumber: "{characters}"
    }),
    formErrorUnknown: strictLocalize({
      id: "uHmA0t",
      defaultMessage: [{
        "type": 0,
        "value": "Il semble y avoir une erreur"
      }]
    }),
    formFieldSelectPlaceholderFallback: strictLocalize({
      id: "IqApqR",
      defaultMessage: [{
        "type": 0,
        "value": "Choisissez-en un…"
      }]
    }),
    frontendEmailChannelDescription: strictLocalize({
      id: "UrftLW",
      defaultMessage: [{
        "type": 0,
        "value": "Pour nous contacter par e-mail, écrivez-nous à notre adresse e-mail et nous vous répondrons sous peu :"
      }]
    }),
    headerText: strictLocalize({
      id: "LzUo5v",
      defaultMessage: [{
        "type": 0,
        "value": "Que pouvons-nous faire pour vous aider ?"
      }]
    }),
    imageClickToReload: strictLocalize({
      id: "MYu9Dn",
      defaultMessage: [{
        "type": 0,
        "value": "Cliquez pour recharger l'image."
      }]
    }),
    imageClickToView: strictLocalize({
      id: "iDcbK1",
      defaultMessage: [{
        "type": 0,
        "value": "Cliquer pour voir l'image en "
      }, {
        "type": 1,
        "value": "sizeNumber"
      }, {
        "type": 0,
        "value": "."
      }]
    }, {
      sizeNumber: "{size}"
    }),
    imagePreviewNotAvailable: strictLocalize({
      id: "7xJ0Oe",
      defaultMessage: [{
        "type": 0,
        "value": "Aperçu non disponible."
      }]
    }),
    inputPlaceholder: strictLocalize({
      id: "Qz0IJv",
      defaultMessage: [{
        "type": 0,
        "value": "Saisissez un message…"
      }]
    }),
    inputPlaceholderBlocked: strictLocalize({
      id: "lKCy+g",
      defaultMessage: [{
        "type": 0,
        "value": "Remplissez le formulaire ci-dessus…"
      }]
    }),
    introAppText: strictLocalize({
      id: "WwisEh",
      defaultMessage: [{
        "type": 0,
        "value": "Envoyez-nous un message ci-dessous ou depuis votre application préférée."
      }]
    }),
    lineChannelDescription: strictLocalize({
      id: "82iecS",
      defaultMessage: [{
        "type": 0,
        "value": "Pour nous contacter en utilisant LINE, scannez ce code QR à l'aide de l'application LINE et envoyez-nous un message."
      }]
    }),
    linkError: strictLocalize({
      id: "hlZfbl",
      defaultMessage: [{
        "type": 0,
        "value": "Une erreur s'est produite lors de la tentative de génération d'un lien pour ce canal. Veuillez réessayer."
      }]
    }),
    linkChannelPageHeader: strictLocalize({
      id: "jSbwQA",
      defaultMessage: [{
        "type": 0,
        "value": "Synchronisez votre conversation"
      }]
    }),
    locationNotSupported: strictLocalize({
      id: "0cajDz",
      defaultMessage: [{
        "type": 0,
        "value": "Votre navigateur ne prend pas en charge les services de localisation, ou ceux-ci ont été désactivés. Saisissez vous-même votre emplacement."
      }]
    }),
    locationSecurityRestriction: strictLocalize({
      id: "Q20rDu",
      defaultMessage: [{
        "type": 0,
        "value": "Ce site Web ne peut pas accéder à votre emplacement. Saisissez vous-même votre emplacement."
      }]
    }),
    locationSendingFailed: strictLocalize({
      id: "XWNAd3",
      defaultMessage: [{
        "type": 0,
        "value": "Impossible d'envoyer l'emplacement"
      }]
    }),
    locationServicesDenied: strictLocalize({
      id: "EavZzB",
      defaultMessage: [{
        "type": 0,
        "value": "Ce site Web ne peut pas accéder à votre emplacement. Autorisez l'accès dans vos paramètres ou saisissez vous-même votre emplacement."
      }]
    }),
    messageIndicatorTitlePlural: strictLocalize({
      id: "0+VvFB",
      defaultMessage: [{
        "type": 1,
        "value": "countNumber"
      }, {
        "type": 0,
        "value": " nouveaux messages"
      }]
    }, {
      countNumber: "{count}"
    }),
    messageIndicatorTitleSingular: strictLocalize({
      id: "CSCZoW",
      defaultMessage: [{
        "type": 1,
        "value": "countNumber"
      }, {
        "type": 0,
        "value": " nouveau message"
      }]
    }, {
      countNumber: "{count}"
    }),
    messageRelativeTimeDay: strictLocalize({
      id: "xo/4Yu",
      defaultMessage: [{
        "type": 0,
        "value": "Il y a "
      }, {
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " jours"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageRelativeTimeHour: strictLocalize({
      id: "bdg3Pr",
      defaultMessage: [{
        "type": 0,
        "value": "Il y a "
      }, {
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " heures"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageRelativeTimeJustNow: strictLocalize({
      id: "72Tqww",
      defaultMessage: [{
        "type": 0,
        "value": "À l'instant"
      }]
    }),
    messageRelativeTimeMinute: strictLocalize({
      id: "SyJ9Zm",
      defaultMessage: [{
        "type": 0,
        "value": "Il y a "
      }, {
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " minutes"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageDelivered: strictLocalize({
      id: "I9y4Q1",
      defaultMessage: [{
        "type": 0,
        "value": "Remis"
      }]
    }),
    messageSeen: strictLocalize({
      id: "2552ol",
      defaultMessage: [{
        "type": 0,
        "value": "Vu"
      }]
    }),
    messageSending: strictLocalize({
      id: "CzlJFq",
      defaultMessage: [{
        "type": 0,
        "value": "Envoi…"
      }]
    }),
    messengerChannelDescription: strictLocalize({
      id: "EBuhyl",
      defaultMessage: [{
        "type": 0,
        "value": "Associez votre compte Facebook Messenger pour recevoir une notification lorsque vous obtenez une réponse et poursuivre la conversation sur Facebook Messenger."
      }]
    }),
    newConversationButtonText: strictLocalize({
      id: "79XsJP",
      defaultMessage: [{
        "type": 0,
        "value": "Nouvelle conversation"
      }]
    }),
    notificationSettingsChannelsDescription: strictLocalize({
      id: "nmmSL2",
      defaultMessage: [{
        "type": 0,
        "value": "Synchronisez cette conversation en vous connectant à votre application de messagerie préférée pour poursuivre la conversation comme vous le souhaitez."
      }]
    }),
    notificationSettingsChannelsTitle: strictLocalize({
      id: "WuUmeV",
      defaultMessage: [{
        "type": 0,
        "value": "Autres canaux"
      }]
    }),
    notificationSettingsConnected: strictLocalize({
      id: "h3RKIm",
      defaultMessage: [{
        "type": 0,
        "value": "Connecté"
      }]
    }),
    notificationSettingsConnectedAs: strictLocalize({
      id: "uepWZ4",
      defaultMessage: [{
        "type": 0,
        "value": "Connexion établie en tant que "
      }, {
        "type": 1,
        "value": "userPersonName"
      }]
    }, {
      userPersonName: "{username}"
    }),
    prechatCaptureGreetingText: strictLocalize({
      id: "JUJtTk",
      defaultMessage: [{
        "type": 0,
        "value": "Bonjour, Pour commencer, nous aimerions en savoir un peu plus sur vous :"
      }]
    }),
    prechatCaptureNameLabel: strictLocalize({
      id: "uLbNUt",
      defaultMessage: [{
        "type": 0,
        "value": "Votre nom"
      }]
    }),
    prechatCaptureNamePlaceholder: strictLocalize({
      id: "RwY05X",
      defaultMessage: [{
        "type": 0,
        "value": "Saisissez votre nom…"
      }]
    }),
    prechatCaptureEmailLabel: strictLocalize({
      id: "kJy+AB",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    prechatCaptureEmailPlaceholder: strictLocalize({
      id: "bHoo9p",
      defaultMessage: [{
        "type": 0,
        "value": "nom@entreprise.com"
      }]
    }),
    prechatCaptureConfirmationText: strictLocalize({
      id: "MxlmAH",
      defaultMessage: [{
        "type": 0,
        "value": "Merci ! Que pouvons-nous faire pour vous aider ?"
      }]
    }),
    prechatCaptureMailgunLinkingConfirmation: strictLocalize({
      id: "qhC82s",
      defaultMessage: [{
        "type": 0,
        "value": "Lorsque nous vous aurons répondu, vous recevrez une notification ici et par e-mail, à l'adresse "
      }, {
        "type": 1,
        "value": "emailEmailAddress"
      }, {
        "type": 0,
        "value": "."
      }]
    }, {
      emailEmailAddress: "{email}"
    }),
    sendButtonText: strictLocalize({
      id: "xLWTdR",
      defaultMessage: [{
        "type": 0,
        "value": "Envoyer"
      }]
    }),
    settingsHeaderText: strictLocalize({
      id: "0QV6z2",
      defaultMessage: [{
        "type": 0,
        "value": "Paramètres"
      }]
    }),
    shareLocation: strictLocalize({
      id: "rvirM2",
      defaultMessage: [{
        "type": 0,
        "value": "Emplacement"
      }]
    }),
    smsBadRequestError: strictLocalize({
      id: "d5wiZz",
      defaultMessage: [{
        "type": 0,
        "value": "Nous n'avons pas pu communiquer avec ce numéro. Réessayez ou utilisez-en un autre."
      }]
    }),
    smsCancel: strictLocalize({
      id: "gHLemI",
      defaultMessage: [{
        "type": 0,
        "value": "Annuler"
      }]
    }),
    smsChangeNumber: strictLocalize({
      id: "T9LQOH",
      defaultMessage: [{
        "type": 0,
        "value": "Modifier mon numéro"
      }]
    }),
    smsChannelDescription: strictLocalize({
      id: "E9/0ru",
      defaultMessage: [{
        "type": 0,
        "value": "Associez votre numéro de mobile pour recevoir une notification lorsque vous obtenez une réponse et poursuivre la conversation par SMS."
      }]
    }),
    smsChannelPendingDescription: strictLocalize({
      id: "spQ3hG",
      defaultMessage: [{
        "type": 0,
        "value": "Vérifiez vos messages au "
      }, {
        "type": 1,
        "value": "phoneNumber"
      }, {
        "type": 0,
        "value": " pour confirmer votre numéro de téléphone."
      }]
    }, {
      phoneNumber: "{number}"
    }),
    smsContinue: strictLocalize({
      id: "xLWTdR",
      defaultMessage: [{
        "type": 0,
        "value": "Envoyer"
      }]
    }),
    smsInvalidNumberError: strictLocalize({
      id: "QaDAmJ",
      defaultMessage: [{
        "type": 0,
        "value": "Saisissez un numéro de téléphone valide."
      }]
    }),
    smsLinkCancelled: strictLocalize({
      id: "q4dN8U",
      defaultMessage: [{
        "type": 0,
        "value": "Le lien vers "
      }, {
        "type": 1,
        "value": "appUserNumber"
      }, {
        "type": 0,
        "value": " a été annulé."
      }]
    }, {
      appUserNumber: "{appUserNumber}"
    }),
    smsLinkPending: strictLocalize({
      id: "I1RY7U",
      defaultMessage: [{
        "type": 0,
        "value": "En attente"
      }]
    }),
    smsPingChannelError: strictLocalize({
      id: "UBAoB1",
      defaultMessage: [{
        "type": 0,
        "value": "Une erreur s'est produite lors de l'envoi d'un message à votre numéro."
      }]
    }),
    smsSendText: strictLocalize({
      id: "x7rAeU",
      defaultMessage: [{
        "type": 0,
        "value": "Recevoir un SMS"
      }]
    }),
    smsStartTexting: strictLocalize({
      id: "TGJUj4",
      defaultMessage: [{
        "type": 0,
        "value": "Commencer à envoyer des SMS"
      }]
    }),
    smsTooManyRequestsError: strictLocalize({
      id: "jVSLkV",
      defaultMessage: [{
        "type": 0,
        "value": "Nous avons récemment reçu une demande de connexion pour ce numéro. Veuillez réessayer dans "
      }, {
        "type": 1,
        "value": "minutesTime"
      }, {
        "type": 0,
        "value": " minutes."
      }]
    }, {
      minutesTime: "{minutes}"
    }),
    smsTooManyRequestsOneMinuteError: strictLocalize({
      id: "0XliGQ",
      defaultMessage: [{
        "type": 0,
        "value": "Une connexion pour ce numéro a été demandée récemment. Veuillez réessayer dans 1 minute."
      }]
    }),
    smsUnhandledError: strictLocalize({
      id: "W1a+Iy",
      defaultMessage: [{
        "type": 0,
        "value": "Une erreur est survenue. Veuillez réessayer."
      }]
    }),
    syncConversation: strictLocalize({
      id: "B2qj3w",
      defaultMessage: [{
        "type": 0,
        "value": "Synchroniser la conversation"
      }]
    }),
    tapToRetry: strictLocalize({
      id: "P7ZSoc",
      defaultMessage: [{
        "type": 0,
        "value": "Le message n'a pas été remis. Appuyez pour réessayer."
      }]
    }),
    tapToRetryForm: strictLocalize({
      id: "QqMyCB",
      defaultMessage: [{
        "type": 0,
        "value": "Le formulaire n'a pas été envoyé. Pour réessayer, appuyez à n'importe quel endroit dans le formulaire."
      }]
    }),
    telegramChannelDescription: strictLocalize({
      id: "Rtuws+",
      defaultMessage: [{
        "type": 0,
        "value": "Associez votre compte Telegram pour recevoir une notification lorsque vous obtenez une réponse et poursuivre la conversation sur Telegram."
      }]
    }),
    unsupportedMessageType: strictLocalize({
      id: "E9qCDM",
      defaultMessage: [{
        "type": 0,
        "value": "Type de message non pris en charge."
      }]
    }),
    unsupportedActionType: strictLocalize({
      id: "mMB611",
      defaultMessage: [{
        "type": 0,
        "value": "Type d'action non pris en charge."
      }]
    }),
    uploadDocument: strictLocalize({
      id: "hdlOID",
      defaultMessage: [{
        "type": 0,
        "value": "Fichier"
      }]
    }),
    uploadInvalidError: strictLocalize({
      id: "gn05y6",
      defaultMessage: [{
        "type": 0,
        "value": "Fichier non valide"
      }]
    }),
    uploadPhoto: strictLocalize({
      id: "OAzZGu",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    }),
    uploadVirusError: strictLocalize({
      id: "x5EOZK",
      defaultMessage: [{
        "type": 0,
        "value": "Un virus a été détecté dans votre fichier et celui-ci a été refusé"
      }]
    }),
    viberChannelDescription: strictLocalize({
      id: "Z3K0oO",
      defaultMessage: [{
        "type": 0,
        "value": "Associez votre compte Viber pour recevoir une notification lorsque vous obtenez une réponse et poursuivre la conversation sur Viber. Pour commencer, scannez le code QR à l'aide de l'application Viber."
      }]
    }),
    viberChannelDescriptionMobile: strictLocalize({
      id: "xuYgMg",
      defaultMessage: [{
        "type": 0,
        "value": "Associez votre compte Viber pour recevoir une notification lorsque vous obtenez une réponse et poursuivre la conversation sur Viber. Pour commencer, installez l'application Viber et appuyez sur Connexion."
      }]
    }),
    viberQRCodeError: strictLocalize({
      id: "AYSCMJ",
      defaultMessage: [{
        "type": 0,
        "value": "Une erreur est survenue lors de la récupération de votre code QR Viber. Veuillez réessayer."
      }]
    }),
    wechatChannelDescription: strictLocalize({
      id: "qIPntD",
      defaultMessage: [{
        "type": 0,
        "value": "Associez votre compte WeChat pour recevoir une notification lorsque vous obtenez une réponse et poursuivre la conversation sur WeChat. Pour commencer, scannez ce code QR à l'aide de l'application WeChat."
      }]
    }),
    wechatChannelDescriptionMobile: strictLocalize({
      id: "4p4TBs",
      defaultMessage: [{
        "type": 0,
        "value": "Associez votre compte WeChat pour recevoir une notification lorsque vous obtenez une réponse et poursuivre la conversation sur WeChat. Pour commencer, enregistrez cette image de code QR et importez-la dans le lecteur de code QR."
      }]
    }),
    wechatQRCodeError: strictLocalize({
      id: "TdTat4",
      defaultMessage: [{
        "type": 0,
        "value": "Une erreur est survenue lors de la récupération de votre code QR WeChat. Veuillez réessayer."
      }]
    }),
    whatsappChannelDescriptionDesktop: strictLocalize({
      id: "tlAllf",
      defaultMessage: [{
        "type": 0,
        "value": "Synchronisez votre compte avec WhatsApp en scannant le code QR ou en cliquant sur le lien ci-dessous. Ensuite, envoyez le message prérempli pour valider la demande de synchronisation. (Votre code : "
      }, {
        "type": 1,
        "value": "codeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      codeNumber: "{code}"
    }),
    whatsappChannelDescriptionMobile: strictLocalize({
      id: "/YEwfr",
      defaultMessage: [{
        "type": 0,
        "value": "Synchronisez votre compte avec WhatsApp en cliquant sur le lien ci-dessous. Ensuite, envoyez le message prérempli pour valider la demande de synchronisation. (Votre code : "
      }, {
        "type": 1,
        "value": "codeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      codeNumber: "{code}"
    }),
    whatsappLinkingError: strictLocalize({
      id: "49auTS",
      defaultMessage: [{
        "type": 0,
        "value": "Une erreur est survenue lors de la récupération de vos informations de liaison WhatsApp. Veuillez réessayer."
      }]
    })
  };
};